import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env, isAuthConfigured } from './env';

/**
 * `null` when VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are missing, so the
 * public catalog still renders on a fresh clone. Guard every use.
 */
export const supabase: SupabaseClient | null = isAuthConfigured
  ? createClient(env.supabaseUrl, env.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export async function getAccessToken(): Promise<string | undefined> {
  if (!supabase) return undefined;
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token;
}
